import { mnemonicToAccount } from "viem/accounts";

/**
 * Derive an EVM address from a BIP-39 mnemonic.
 *
 * EVM addresses are chain-agnostic — the same private key produces the
 * same 0x address on every chain. We expose a single accessor; the
 * caller decides which chain(s) to query.
 *
 * viem follows the canonical Ethereum HD path (`m/44'/60'/0'/0/<index>`)
 * by default when given an `accountIndex`, so the resulting address
 * matches what MetaMask / Rabby would derive from the same seed.
 */
export function deriveEvmAddress(
  phrase: string,
  accountIndex = 0,
): `0x${string}` {
  const account = mnemonicToAccount(phrase, { accountIndex });
  return account.address;
}
